import { createGlobalStyle } from 'styled-components'

const PopupStyle = createGlobalStyle`
    .deactivate-popup {
        background-color: var(--white);
        max-width: var(--sp80x);
        width: 100%;
        padding:var(--sp5x);
        border-radius:20px;

        .sub {
            margin:var(--sp3x) 0 var(--sp2x);
        }

        .text {
            margin-bottom:var(--sp5x);
            padding-bottom:var(--sp5x);
            border-bottom: 1px solid var(--lightGrey);
        }

        .buttons {
            align-self: flex-end;

            .red {
                margin-left:var(--sp2x);
            }
        }
    }

    .delete-draft-popup {
        background-color: var(--white);
        max-width: var(--sp50x);
        width: 100%;
        padding:var(--sp5x);
        border-radius:20px;
        position: relative;
        align-items:center;

        .op-close {
            position: absolute;
            top:var(--sp5x);
            right:var(--sp5x);
            cursor: pointer;
            font-size: var(--sp2x);
        }

        .text {
            margin-top:var(--sp4x);
            margin-bottom:var(--sp3x);
        }

        .buttons {
            button {
                padding:6px var(--sp2x);
                border:none;
                border-radius:var(--spSize);
                background-color:#B2B2B2;
                color:var(--white);
                font-family:PopSemi;
                transition:var(--trTime);

                &:hover {
                    opacity: 0.7;
                }
                
                &:nth-child(2){
                    margin-left:var(--sp3x);
                }

                &.yes {
                    background-color:var(--green);
                }
            }
        }
    }
    
    .add-pro-con-popup,
    .submit-report-popup {
        background-color: var(--white);
        max-width: var(--sp80x);
        width: 100%;
        padding:var(--sp5x);
        border-radius:20px;
        position: relative;

        .op-close {
            position: absolute;
            top:var(--sp5x);
            right:var(--sp5x);
            cursor: pointer;
            font-size: var(--sp2x);
        }

        .text {
            margin-top:var(--sp5x);
            margin-bottom:var(--sp3x);
        }

        .input-text {
      &.ant-input-textarea {
        padding:0;
  
        &:after {
          margin-top:8px;
        }
  
        textarea {
          border:none;
          border-radius: 12px;
          outline:none;
          padding:var(--inputTextPadding);
  
          &:focus {
            caret-color: var(--purple);
            border:none !important;
            box-shadow: unset;
          }
        }
      }
    }

        .buttons {
            align-self: flex-end;
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        .deactivate-popup {
            max-width: unset;
            width: calc(100% - var(--sp4x));
            padding:var(--sp2-5x);

            .sub {
                margin:var(--sp2x) 0;
                max-width: 70%;
            }

            .text {
                margin-bottom:var(--sp3x);
                padding-bottom:var(--sp3x);
                max-width: 85%;
            }

            .buttons {
                justify-content: space-between;
                .red {
                    margin-left:0;
                }
            }
        }

        .delete-draft-popup {
            max-width: calc(100% - var(--sp4x));
            padding:var(--sp2-5x);

            .op-close {
                top:var(--sp2-5x);
                right:var(--sp2-5x);
                font-size: var(--sp2x);
            }

            .text {
                margin-top:var(--sp3x);
                margin-bottom:var(--sp2x);
            }
        }
        
        .add-pro-con-popup,
        .submit-report-popup {
            max-width: unset;
            width: calc(100% - var(--sp4x));
            padding:var(--sp2-5x);

            .op-close {
                top:var(--sp2-5x);
                right:var(--sp2-5x);
                font-size: var(--sp2x);
            }

            .text {
                margin-top:var(--sp3x);
                margin-bottom:var(--sp2x);
            }
        }
    }
`

export default PopupStyle
